import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class TipoMultaService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getTiposMulta(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/tiposmulta' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getTipoMulta(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/tiposmulta/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaTipoMulta(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/tiposmulta', {
				tipo_multa_nome: data.tipo_multa_nome,
				tipo_multa_descricao: data.tipo_multa_descricao,
				tipo_multa_pontuacao: data.tipo_multa_pontuacao,
				tipo_multa_natureza: data.tipo_multa_natureza,
				tipo_multa_valor: data.tipo_multa_valor,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaTipoMulta(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/tiposmulta/' + data.tipo_multa_id, {
				tipo_multa_nome: data.tipo_multa_nome,
				tipo_multa_descricao: data.tipo_multa_descricao,
				tipo_multa_pontuacao: data.tipo_multa_pontuacao,
				tipo_multa_natureza: data.tipo_multa_natureza,
				tipo_multa_valor: data.tipo_multa_valor,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaTipoMulta(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/tiposmulta/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
